// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

const emailsUrl = "/api/v1/email";

export function storeSubmitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrl}/store/contactUs`, parameter);
}
